import { render, staticRenderFns } from "./location-filter-map-region.vue?vue&type=template&id=4282239a&scoped=true"
import script from "./location-filter-map-region.vue?vue&type=script&lang=js"
export * from "./location-filter-map-region.vue?vue&type=script&lang=js"
import style0 from "./location-filter-map-region.vue?vue&type=style&index=0&id=4282239a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4282239a",
  null
  
)

export default component.exports